import React, {useState, useEffect, useRef} from 'react';
import {
    ReactComponent as FilterIcon
} from '../../../../../../../../assets/main/groups/main-table/period-calendar/filter.svg';
import {
    StudentsFilterComponent
} from "components/pages/groups/group-container/students/students-pages/students-timetable/students-filter/students-filter-component/StudentsFilterComponent";


export interface Filters {
    isNew: boolean;
    finished: boolean;
    has_problem: boolean;
}


interface IStudentsFilter {
    setSendFilter: React.Dispatch<React.SetStateAction<boolean>>;
}


export const StudentsFilter = ({setSendFilter}: IStudentsFilter) => {
    const [showFilter, setShowFilter] = useState(false);


    const filterRef = useRef<HTMLDivElement | null>(null);

    const handleFilterComponentClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        // Остановите всплытие события, чтобы избежать закрытия фильтра
        event.stopPropagation();
    };

    const handleDocumentClick = (event: MouseEvent) => {
        // Проверяем, был ли клик вне области фильтра и фильтр в данный момент развернут
        if (filterRef.current && !filterRef.current.contains(event.target as Node) && showFilter) {
            setShowFilter(false);
        }
    };

    const handleFilterBlockClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        // Если фильтр уже открыт, не прекращаем распространение события
        if (showFilter) {
            return;
        }

        // Если фильтр закрыт, прекращаем распространение события
        event.stopPropagation();

        // И открываем фильтр
        setShowFilter(true);
    };

    useEffect(() => {
        document.addEventListener('click', handleDocumentClick);

        return () => {
            document.removeEventListener('click', handleDocumentClick);
        };
    }, [showFilter]);

    return (
        <>
            <div
                ref={filterRef}
                className={`nav-block filter-block ${showFilter ? 'active' : ''}`}
                onClick={handleFilterBlockClick}
            >
            <span>
                <FilterIcon/>
            </span>
                <span className='filter-title'>Фильтр</span>
            </div>
            {showFilter && (
                <StudentsFilterComponent
                    onClick={handleFilterComponentClick}
                    ref={filterRef}
                    setShowFilter={setShowFilter}
                    showFilter={showFilter}
                    setSendFilter={setSendFilter}
                />
            )}
        </>
    );
};
